import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_NUMBERS_CONCEIVED_MONTHS {
  ID_MONTH1 = '1',
  ID_MONTH2 = '2',
  ID_MONTH3 = '3',
  ID_MONTH4 = '4',
  ID_MONTH5 = '5',
  ID_MONTH6 = '6',
  ID_MONTH7 = '7',
  ID_MONTH8 = '8',
  ID_MONTH9 = '9',
}

const conceivedMonths = Object.freeze([
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH1,
    value: '1',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH2,
    value: '2',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH3,
    value: '3',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH4,
    value: '4',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH5,
    value: '5',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH6,
    value: '6',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH7,
    value: '7',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH8,
    value: '8',
  },
  {
    id: ID_NUMBERS_CONCEIVED_MONTHS.ID_MONTH9,
    value: '9',
  },
]);

interface ListNumberConceivedProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  label?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListNumberConceivedComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  label = 'Concepito da mesi',
  isSmallSize = false,
}: ListNumberConceivedProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="conceivedMonth-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="conceivedMonth-label"
        id="conceivedMonth"
        name="conceivedMonth"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {conceivedMonths.map((conceivedMonth: ItemVM) => (
          <MenuItem key={conceivedMonth.id} value={conceivedMonth.id}>
            {conceivedMonth.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListNumberConceivedComponent.displayName = 'List Number Conceived component';

const ListNumberConceived = memo(ListNumberConceivedComponent);

export default ListNumberConceived as typeof ListNumberConceivedComponent;
